import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'svg-frontends-option-container',
	styleUrls: ['./option-container.component.scss'],
	templateUrl: './option-container.component.html',
	standalone: false,
})
export class OptionContainerComponent {
	@Input() description?: string | TemplateRef<any>;
	@Input() label: string | TemplateRef<any>;
	@Input() selected: boolean;
	@Input() disabled = false;
}
